export default {"src":"/_next/static/media/404.255c418b.svg","height":960,"width":790,"blurWidth":0,"blurHeight":0};